


















import { Vue, Component } from "nuxt-property-decorator";
import GrButton from "~/components/common/GrButton.vue";
import MaxWidthSection from "~/components/common/MaxWidthSection.vue";
import TwoColumnRow from "~/components/common/TwoColumnRow.vue";
import WhyGritifyCompany from "~/components/startPageNew/WhyGritifyCompany.vue";
import CompanyCarousel from "~/components/startPageNew/CompanyCarousel.vue";
import GrMoviePlayer from "~/components/startPageNew/GrMoviePlayer.vue";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";
import PricingCompany from "~/components/startPageNew/PricingCompany.vue";
import CompanyStories from "~/components/startPageNew/CompanyStories.vue";
import GrBottomBackground from "~/components/common/GrBottomBackground.vue";
import CompanyPageFirstPage from "~/components/common/CompanyPageFirstPage.vue";
import CompanyPageSecondPage from "~/components/common/CompanyPageSecondPage.vue";
import WhatOurCustomersThink from "~/components/common/WhatOurCustomersThink.vue";
import BottomInterestForm from "~/components/common/BottomInterestForm.vue";
import QuarterlyUpdateBanner from "~/components/QuarterlyUpdateBanner.vue";

// import gsap from "gsap";

@Component({
  layout: "companyPublicLayout",
  components: {
    GrButton,
    MaxWidthSection,
    GrMoviePlayer,
    TwoColumnRow,
    CompanyCarousel,
    WhyGritifyCompany,
    GrPublicFooter,
    PricingCompany,
    CompanyStories,
    GrBottomBackground,
    CompanyPageFirstPage,
    CompanyPageSecondPage,
    WhatOurCustomersThink,
    BottomInterestForm,
    QuarterlyUpdateBanner,
  },
})
export default class TalentStartPage extends Vue {
  mounted() {
    const hash = this.$route.hash;
    if (hash) {
      this.goToPath(this.$route.fullPath);
    }
  }

  async goToPath(path: string) {
    if (this.$route.hash) {
      await this.$router.replace(path.split("#")[0]!);
    }
    this.$router.replace(path);
  }

  goToAnchor(v: string) {
    this.$vuetify.goTo(v, { offset: -104, duration: 200 });
  }

  head() {
    return {
      title: this.$t("Titel i tabben").toString(),
    };
  }
}
